import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Button, Card, Col, Container, Form, Jumbotron, Row } from 'react-bootstrap';
import { useisLoading } from '../../hook/useisLoading';
import Loading from '../../components/common/Loading';
import InputField from '../../components/common/InputField';
import Checkbox from '../../components/common/Checkbox';
import { useForm } from 'react-hook-form';
import PageHeaderStandar from '../../components/common/PageHeaderStandar';
import { ButtonBack } from '../../components/common/ButtonBack';
import ErrorMessage from '../../components/common/ErrorMessage';
import { helperConfirmationAlert } from '../../components/helpers/helperConfirmationAlert';
import { Redirect } from 'react-router-dom';
import { set } from 'react-global-configuration';
import { ButtonEdit } from '../../components/common/ButtonEdit';
import SelectCombobox from '../../components/common/SelectCombobox';
import { BillingAPI } from '../../components/apis/billing';
import types from '../../types/types';


export const CustomerPlan = (props, context) => {

    console.log("Enter into CustomerPlan.js");
    
    const { token } = useSelector(state => state.user);
    const [apiBilling, setApiBilling] = useState(null);

    // Variable to show/hide "spinner" while loading page.
    const { isLoading, showSpinner, hideSpinner } = useisLoading(true);

    // Stander useForm of react-hook-form Library
    const { register, handleSubmit, getValues, setValue, formState: { errors } } = useForm({
        defaultValues: {
            // Default attribute for create new entity
            
            // id: null,

            // customer: "Proagile",
            // plan_id: 3,

            // plan_id: 3,
            // plan_discount: 70,
            // surplus_discount: 80,

            // new_plan_id: 3,
            // new_plan_discount: 70,
            // new_surplus_discount: 80,

            // plan_name: "Corporate",
            // plan_api_calls: "1.500.000",
            // plan_cost: "USD 500",
            // plan_api_call_surplus: "USD 0.00200",
            // customer_plan_created_date: "2022-07-15T15:16:27-03:00",

            // plan_effective_date: "01/01/2022",
            // plan_discharge_effective_date: "01/01/2999",
            // plan_expiration_date: "NO",
            // plan_discharge_expiration_date: "NO",

            // has_discount: "YES",
            // discount_rate: "70%",
            // has_surplus_discount: "YES",

            plan_account_id: null,
            plan_id: null,
            account_id: null,
            plan_account_modifications_id: null,
            element_id: null,
            snx_name: "",
            snx_description: "",
            business_name: "",
            business_description: "",
            enabled: true,
            name: "",
            name_client: "",
            description: "",
            desc_client: "",
            quantity: -1,
            cost: -1,
            excedent: null,
            percentage: null,
            discount_cost: false,
            discount_excd: false,
            billing: true,
            monitoring: true,
            currency: 0,
            element_start_at: "",
            element_end_at: null,
            element_created_at: "",
            element_deleted_at: null,
            plan_created_at: "",
            plan_deleted_at: null,
            plan_account_start_at: "",
            plan_account_end_at: null,
            plan_account_created_at: "",
            plan_account_deleted_at: null,
            apply_element_id: null,
            plan_account_mofications_start_at: null,
            plan_account_mofications_end_at: null,
            plan_account_mofications_created_at: null,
            plan_account_mofications_deleted_at: null,            
            
            // backendError is used to set back-end-error message when service has fail (to show to the user)
            backendError: null,
            
        }
    });

    const [goToManagement, setGoToManagement] = useState(false);

    // We controls if user press "pen" button to make Entity editable.
    const [isEditable, setIsEditable] = useState(window.location.pathname.includes('/customerplan/edit'));

    const [plans, setPlans] = useState(null);
    const [discount, setDiscount] = useState(null);
    const [apiPlans, setApiPlans] = useState(null);

    const [user, setUser] = useState(null);
    
    // Load API Object
    useEffect(() => {
        if (token) {

            setApiBilling(new BillingAPI(token));
        }

    }, [token])

    
    // Use effect to load customer (Account) plan data from managment API.
    useEffect( () => {
        if (apiBilling){
            
            showSpinner();    
            apiBilling.getSnxBillingAccountPlanById(props.id).then(  (planElements) => {

                planElements.forEach( element => {
                    
                    setValue("plan_account_id", element.plan_account_id);
                    setValue("plan_id", element.plan_id);
                    setValue("account_id", element.account_id);
                    setValue("plan_account_modifications_id", element.plan_account_modifications_id);
                    setValue("element_id",element.element_id);
                    setValue("snx_name", element.snx_name);
                    setValue("snx_description",  element.snx_description);
                    setValue("business_name",element.business_name);
                    setValue("business_description", element.business_description);
                    setValue("enabled", element.enabled);
                    setValue("name", element.name);
                    setValue("name_client", element.name_client);
                    setValue("description", element.description);
                    setValue("desc_client", element.desc_client);
                    setValue("quantity", element.quantity);
                    setValue("cost", element.cost);
                    setValue("excedent",element.excedent);
                    setValue("percentage",element.percentage);
                    setValue("discount_cost", element.discount_cost);
                    setValue("discount_excd",element.discount_excd);
                    setValue("billing", element.billing);
                    setValue("monitoring", element.monitoring);
                    setValue("currency",element.currency);
                    setValue("element_start_at",element.element_start_at);  
                    setValue("element_end_at", element.element_end_at);
                    setValue("element_created_at", element.element_created_at);
                    setValue("element_deleted_at", element.element_deleted_at);
                    setValue("plan_created_at",element.plan_created_at);
                    setValue("plan_deleted_at",element.plan_deleted_at);
                    setValue("plan_account_start_at",  element.plan_account_start_at);
                    setValue("plan_account_end_at", element.plan_account_end_at);
                    setValue("plan_account_created_at",  element.plan_account_created_at);
                    setValue("plan_account_deleted_at",  element.plan_account_deleted_at);
                    setValue("apply_element_id", element.apply_element_id);
                    setValue("plan_account_mofications_start_at",element.plan_account_mofications_start_at);
                    setValue("plan_account_mofications_end_at", element.plan_account_mofications_end_at);
                    setValue("plan_account_mofications_created_at", element.plan_account_mofications_created_at);
                    setValue("plan_account_mofications_deleted_at", element.plan_account_mofications_deleted_at);
                    
                });

            }).catch(err => {
                console.log("Error getting customer (Account) plan data from PlanEdition.js: " + err)
                setValue(types.ERROR,  context.t("There was a problem on our end. Please try again later."));

            }).finally(() => {

                hideSpinner();

            });
        }

    }, [apiBilling]);

    useEffect( () => {
        
        if (apiPlans){
            hideSpinner();
            
            setPlans( [// "plans":
                            {
                                id: 0,
                                name: "Basic",
                            },
                            {
                                id: 1,
                                name: "Professional",
                            },
                            {
                                id: 2,
                                name: "Business",
                            },
                            {
                                id: 3,
                                name: "Corporate",
                            },
                    ]
            );
            setDiscount( [// "plans discount":
                            {id: 0,name: "0%",},
                            {id: 1,name: "1%",},
                            {id: 2,name: "2%",},
                            {id: 3,name: "3%",},
                            {id: 5,name: "4%",},
                            {id: 6,name: "6%",},
                            {id: 7,name: "7%",},
                            {id: 8,name: "8%",},
                            {id: 9,name: "9%",},
                            {id: 10,name: "10%",},
                            {id: 11,name: "11%",},
                            {id: 12,name: "12%",},
                            {id: 13,name: "13%",},
                            {id: 14,name: "14%",},
                            {id: 15,name: "15%",},
                            {id: 16,name: "16%",},
                            {id: 17,name: "17%",},
                            {id: 18,name: "18%",},
                            {id: 19,name: "19%",},
                            {id: 20,name: "20%",},
                            {id: 21,name: "21%",},
                            {id: 22,name: "22%",},
                            {id: 23,name: "23%",},
                            {id: 24,name: "24%",},
                            {id: 25,name: "25%",},
                            {id: 30,name: "30%",},
                            {id: 35,name: "35%",},
                            {id: 40,name: "40%",},
                            {id: 45,name: "45%",},
                            {id: 50,name: "50%",},
                            {id: 55,name: "55%",},
                            {id: 60,name: "60%",},
                            {id: 65,name: "65%",},
                            {id: 70,name: "70%",},
                            {id: 75,name: "75%",},
                            {id: 80,name: "80%",},
                            {id: 85,name: "85%",},
                            {id: 90,name: "90%",},
                            {id: 95,name: "95%",},
                            {id: 100,name: "100%",},
                    ]
            );
        }

    }, [apiPlans]);


    // Function to change Customer Plan
    const _changePlan = () => {
        
        // REPLACE WHEN SERVICES HAS ALREADY EXISTS
        alert("The plan has been changes successfully");
        // // Starting spinner
        // showSpinner();
        // debugger
        
        // const userId = getValues().id;
        // const userAccountId=  getValues().account_id;

        // apiUser.delete(userId).then(() => {

        //     setValue("goToUsersList", '/users');
        //     message(context.t("User deleted"), context.t("User deleted successfully"));
            
        // }).catch(err => {

        //     console.log(err);
        //     // Set "backendError" show a back-end error as message to the user at the top.
        //     setValue("backendError",  err.message );

        // }).finally(() => {
        //     // Stop spinnner and render page.
        //     hideSpinner();

        // });
    }

    // Function to handle plan changes. It shows a popup confirmaton to the user.
    const handleChangePlan = (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        helperConfirmationAlert(context, "Change you plan", "Actual plan: '{NAME_OLD_PLAN}' - {$ 500} per month (excluding taxes). New plan: {NAME_NEW_PLAN} - {$ 800} per month (excluding taxes). Your new plan starts on {DATE}.", context.t("Confirm change"), context.t("No"), _changePlan, null );
        
    }

    // Redirecting to management page
    if (goToManagement){
        return <Redirect to={ '/management' } />
    }
   
    if (isLoading && !plans) {
        return <Loading/>
    } else {
        return  (
                <div>
                    <Container fluid>
                        {/* If "backendError" has value, it shows to the user */}
                        <ErrorMessage message={getValues().backendError}/>

                        {/* Page header has Title and Subtite of the page */}
                        <PageHeaderStandar title={context.t('Customer Plan')} subtitle={ (isEditable)?context.t('Edit'):context.t('Visualization')} />

                        <Form action={'/customerplan/edit/'+ getValues().plan_id} validate="true">
                            <Card className='snx-card' style={{ padding: "15px"}} >
                                    <Row>
                                    <Col lg="5" className='mb-4'>
                                        <Card>
                                            <Card.Header className="border-bottom text-center">
                                                <div>
                                                    <i className="material-icons snx-icon md-48">shopping_cart</i>
                                                </div>
                                                <h3>{ getValues().business_name }</h3>
                                                <br/>
                                                <span>
                                                    <b>{context.t('Price')}: </b><i className="snx-icon">{ getValues().cost } { (0 == getValues().currency)?"USD": getValues().currency}</i>
                                                </span>
                                                <br/>
                                                <span>
                                                    <b>{context.t('Plan Discount')}: </b><i className="snx-icon">{ getValues().discount_rate }</i>
                                                </span>
                                                <br/>
                                                <span>
                                                    <b>{context.t('Surplus Discount')}: </b><i className="snx-icon">{ getValues().surplus_discount }</i>
                                                </span>
                                                <br/>
                                            </Card.Header>
                                            <Card.Body className="text-center">
                                                <strong className="text-muted d-block mb-2">{context.t('Edit')}</strong>
                                                <ButtonEdit to={'/customerplan/edit/'+ getValues().plan_id} />
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col lg="7">
                                        <Card>
                                            <Card.Header className="border-bottom">
                                                <h6 className="m-0" style={{ float: "left"}}>{context.t('Customer plan setup')}</h6>
                                                
                                                <ButtonBack onClick={() => { setGoToManagement(true) }} />
                                            </Card.Header>
                                            <Card.Body className="pt-0">
                                                <Row className="border-bottom py-2 bg-light">
                                                    <Col sm="12" className="mb-2 mb-sm-0" style={{paddingTop: "7px"}}>
                                                        <b><i className="material-icons">access_time</i> { getValues().customer_plan_created_date }</b>
                                                    </Col>
                                                </Row>
                                                <br/>
                                                <Row>
                                                    <Col>
                                                        <Jumbotron className='m-0 p-3 font-weight-light'>
                                                            <SelectCombobox
                                                                name= "plan_id" 
                                                                label={ context.t('Plans') }
                                                                valueOptions={ plans } 
                                                                disabled={!isEditable}
                                                                errors={ errors }
                                                                useFormRegister= {
                                                                    register("plan_id", {        
                                                                        required: context.t("Must select an option"),
                                                                    })
                                                                }
                                                            />
                                                            <b>{context.t('Name')}:</b>  {getValues().plan_name }
                                                            <br/>
                                                            <b>{context.t('Api Calls')}:</b>  {getValues().plan_api_calls }
                                                            <br/>
                                                            <b>{context.t('Plan cost')}:</b>  {getValues().plan_cost }
                                                            <br/>
                                                            <b>{context.t('Surplus*')}:</b>  {getValues().plan_api_call_surplus }
                                                            <br/>
                                                            <b>{context.t('Plan creation date')}:</b>  {getValues().customer_plan_created_date }
                                                            <br/>
                                                            <sub>{context.t('*Surplus unit price per API call')}</sub>
                                                        </Jumbotron>
                                                        <br/>
                                                        <SelectCombobox
                                                            name= "plan_discount" 
                                                            label={ context.t('Plan Discount') }
                                                            valueOptions={ discount }                                                             
                                                            disabled={!isEditable}
                                                            errors={ errors }
                                                            useFormRegister= {
                                                                register("plan_discount", {        
                                                                    required: context.t("Must select an option"),
                                                                })
                                                            }
                                                        />
                                                        <SelectCombobox
                                                            name= "plan_discount" 
                                                            label={ context.t('Surplus Discount') }
                                                            valueOptions={ discount } 
                                                            disabled={!isEditable}
                                                            errors={ errors }
                                                            useFormRegister= {
                                                                register("surplus_discount", {        
                                                                    required: context.t("Must select an option"),
                                                                })
                                                            }
                                                        />
                                                        {(isEditable)?
                                                            <Row className="pull-right float-right">
                                                                <Button variant="outline-secondary mb-2 mr-1" onClick={(e) => setGoToManagement(true)}>{context.t("Cancel")}</Button>
                                                                <Button variant="outline-primary mb-2 mr-1" onClick={(e) => handleChangePlan(e)}>{context.t("Change plan")}</Button>
                                                            </Row>
                                                        :
                                                            ""
                                                        }
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Card>
                        </Form>
                    </Container>
                    <br/>
                </div>
            )
    }
}

CustomerPlan.contextTypes = {
    t: PropTypes.func.isRequired
}

export default CustomerPlan

